import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';

import { useAppWithNotificationsSelector } from '../hooks/useAppWithNotificationsSelector';
import { dismissDialog } from '../store/notificationsSlice';

export function NotifierDialog() {
  const dialog = useAppWithNotificationsSelector((state) => state.notifications.dialog);
  const dispatch = useDispatch();

  if (dialog == null) return null;

  return (
    <Dialog open>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{dialog.message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pr: 1 }}>
        <Button
          sx={{ m: 1 }}
          size="small"
          variant="contained"
          onClick={() => {
            dispatch(dismissDialog());
          }}
        >
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
}
